'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AlarmRowDirective;

var _alarmDetailsDialogTpl = require('./alarm-details-dialog.tpl.html');

var _alarmDetailsDialogTpl2 = _interopRequireDefault(_alarmDetailsDialogTpl);

var _alarmRowTpl = require('./alarm-row.tpl.html');

var _alarmRowTpl2 = _interopRequireDefault(_alarmRowTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function AlarmRowDirective($compile, $templateCache, types, $mdDialog, $document) {

    var linker = function linker(scope, element, attrs) {

        var template = $templateCache.get(_alarmRowTpl2.default);
        element.html(template);

        scope.alarm = attrs.alarm;
        scope.types = types;

        scope.showAlarmDetails = function ($event) {
            var onShowingCallback = {
                onShowing: function onShowing() {}
            };
            $mdDialog.show({
                controller: 'AlarmDetailsDialogController',
                controllerAs: 'vm',
                templateUrl: _alarmDetailsDialogTpl2.default,
                locals: {
                    alarmId: scope.alarm.id.id,
                    allowAcknowledgment: true,
                    allowClear: true,
                    displayDetails: true,
                    showingCallback: onShowingCallback
                },
                parent: angular.element($document[0].body),
                targetEvent: $event,
                fullscreen: true,
                skipHide: true,
                onShowing: function onShowing(scope, element) {
                    onShowingCallback.onShowing(scope, element);
                }
            }).then(function (alarm) {
                if (alarm) {
                    scope.alarm = alarm;
                }
            });
        };

        $compile(element.contents())(scope);
    };

    return {
        restrict: "A",
        replace: false,
        link: linker,
        scope: false
    };
}


// WEBPACK FOOTER //
// ./src/app/alarm/alarm-row.directive.js